import _ from 'lodash';
import { useEffect } from 'react';
import { useAppSelector } from 'hooks/redux';

import { authSelectors } from 'app-components/flux/auth';
import { subscriptionsSelectors } from 'app-components/flux/subscriptions';
import { getLogger, tracker } from 'app-components/utils/core';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import mixpanel from 'utils/core/mixpanel';
import { getMixpanelDefaultProperties, getMixpanelUserData } from 'data/mixpanel/mixpanelSelectors';

const log = getLogger('utils/mixpanel.js');

const Mixpanel = () => {
  const authSession = useAppSelector(authSelectors.getAuthSession);
  const mixpanelUserData = useAppSelector(getMixpanelUserData);
  const mixpanelDefaultProps = useAppSelector(getMixpanelDefaultProperties);
  const subscriptionTrackingProps = useAppSelector((state) =>
    subscriptionsSelectors.getSubscriptionTrackingProps(state, authSession?.datasetId),
  );

  useEffect(() => {
    const subscriptionProps: Record<string, any> = {};
    Object.keys(subscriptionTrackingProps).forEach((propName) => {
      subscriptionProps[_.snakeCase(propName)] = subscriptionTrackingProps[propName];
    });
    log.debug('\nmixpanel identify: \n', {
      userId: authSession.qcsId,
      mixpanelDefaultProps,
      subscriptionProps,
      mixpanelUserData,
    });
    tracker.setDefaultProperties({ ...mixpanelDefaultProps, ...subscriptionProps });
    if (authSession.qcsId) {
      tracker.identify(authSession.qcsId);
      tracker.updateProfile(mixpanelUserData);
    }
  }, [authSession.qcsId, mixpanelUserData, mixpanelDefaultProps, subscriptionTrackingProps]);

  const mixpanelSessionReplay = useAppSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'mixpanelSessionReplay'),
  );
  useEffect(() => {
    if (mixpanelSessionReplay) {
      mixpanel?.start_session_recording?.();
    } else {
      mixpanel?.stop_session_recording?.();
    }
  }, [mixpanelSessionReplay]);

  return null;
};

export default Mixpanel;
